import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";

export function ResetMatrixCommand() {
    const gameplay = GameState.getCurrentGame();
    const record = gameplay.getCurrentRecord() as SpinRecord;

    // Can't reset reels during recovered game
    if (!gameplay.isRecovered) {
        if (record.stops) {
            Components.matrix.jump(record.stops, record.reelset);
        } else {
            Components.matrix.jumpToGrid(record.grid);
        }
    }
}
